<template>
  <div id="app">
    <v-app>
      <NavigationFrame v-if="showNav"/>

      <v-main>
        <AppLoader/>
        <AppSnackbar/>
        <AppDialog/>

        <router-view/>
      </v-main>
    </v-app>
  </div>
</template>

<script>
import AppSnackbar from '@/components/app/AppSnackbar.vue';
import NavigationFrame from '@/components/NavigationFrame.vue';
import AppDialog from '@/components/app/AppDialog.vue';
import AppLoader from '@/components/app/AppLoader.vue';

export default {
  name: 'app',
  components: {
    AppLoader,
    AppDialog,
    AppSnackbar,
    NavigationFrame,
  },

  data() {
    return {
      showNav: true,
    };
  },

  watch: {
    $route() {
      this.showNav = this.$route.path !== '/login';
    },
  },

  created() {
    this.showNav = this.$route.path !== '/login';
  },

};

</script>

<style lang="scss">
html {
  overflow-y: auto;
}

#app {
  background: #FAFAFA;
}
</style>
